/**
 * Utility functions for spinning wheel components
 */

/**
 * Get the color index for a segment based on the pattern logic
 */
function getColorIndex(segmentIndex: number, totalSegments: number): number {
  if (totalSegments % 2 === 0) {
    // Even number: use colors 1,2 (bright blue, deep blue for contrast)
    return segmentIndex % 2;
  } else {
    // Odd number: use specific patterns
    if (totalSegments === 3) {
      // 3 segments: 1,2,3
      const pattern = [0, 1, 2];
      return pattern[segmentIndex % pattern.length] ?? 0;
    } else if (totalSegments === 5) {
      // 5 segments: 1,2,3,1,2
      const pattern = [0, 1, 2, 0, 1];
      return pattern[segmentIndex % pattern.length] ?? 0;
    } else if (totalSegments === 7) {
      // 7 segments: 1,2,3,4,1,2,3
      const pattern = [0, 1, 2, 3, 0, 1, 2];
      return pattern[segmentIndex % pattern.length] ?? 0;
    } else {
      // For 8+ or other odd numbers, use all 4 colors in loop
      return segmentIndex % 4;
    }
  }
}

/**
 * Generate dynamic wheel colors based on index and total segments
 * Uses CSS variables from the theme for consistent styling
 */
export function generateWheelColor(index: number, totalSegments: number): string {
  // Use CSS variables defined in theme.css
  const colors = [
    "var(--color-wheel-blue-1)", // Bright blue (Cede Primary)
    "var(--color-wheel-blue-2)", // Deep blue
    "var(--color-wheel-blue-3)", // Light blue
    "var(--color-wheel-blue-4)", // Very dark blue
  ];

  const colorIndex = getColorIndex(index, totalSegments);
  return colors[colorIndex] ?? colors[0] ?? "var(--color-wheel-blue-1)";
}
